import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {constants} from '@neosvoc/nv-platform-core-common';
import StaticTextType from './types/StaticTextType';
import StringType from './types/StringType';
import NumberType from './types/NumberType';
import DateType from './types/DateType';
import SingleChoiceType from './types/SingleChoiceType';
import SingleChoiceBatteryType from './types/SingleChoiceBatteryType';
import MultipleChoiceBatteryType from './types/MultipleChoiceBatteryType';
import MultipleNumber3Type from './types/MultipleNumber3Type';
import MultipleChoiceType from './types/MultipleChoiceType';
import TitleType from './types/TitleType';
import LinkType from './types/LinkType';
import StaticImageGalleryType from './types/StaticImageGalleryType';
import ImageType from './types/ImageType';
import GeoType from './types/GeoType';
import RankType from './types/RankType';

export class Content extends Component {
    render() {
        const {content, instanceId, lang, value, previousContent, nextContent} = this.props;
        const params = {
            id: content.id,
            value,
        };

        switch (content.type) {
            case constants.CONTENT_TYPES.TITLE:
                return <TitleType title={content.title} titleHtml={content.titleHtml} subtitle={content.subtitle} />;
            case constants.CONTENT_TYPES.STATIC_IMAGE_GALLERY:
                return <StaticImageGalleryType images={content.images} ratio={content.ratio} nextContent={nextContent} />;
            case constants.CONTENT_TYPES.STATIC_TEXT:
                return <StaticTextType text={content.text} textHtml={content.textHtml} />;
            case constants.CONTENT_TYPES.STRING:
                return <StringType {...params} required={content.required} multiline={content.multiline} />;
            case constants.CONTENT_TYPES.NUMBER:
                return <NumberType {...params} min={content.min} max={content.max} step={content.step} interval={content.interval} origin={content.origin}
                    style={content.style} minLabel={content.minLabel} maxLabel={content.maxLabel} required={content.required}
                    exclusiveChoice={content.exclusiveChoice} />;
            case constants.CONTENT_TYPES.DATE:
                return <DateType {...params} min={content.min} max={content.max} required={content.required} lang={lang} />;
            case constants.CONTENT_TYPES.SINGLE_CHOICE:
                return <SingleChoiceType {...params} choices={content.choices} required={content.required} style={content.style}
                    previousContent={previousContent} />;
            case constants.CONTENT_TYPES.MULTIPLE_CHOICE:
                return <MultipleChoiceType {...params} choices={content.choices} min={content.min} max={content.max} required={content.required}
                    previousContent={previousContent} />;
            case constants.CONTENT_TYPES.SINGLE_CHOICE_BATTERY:
                return <SingleChoiceBatteryType {...params} choices={content.choices} required={content.required} rows={content.rows} />;
            case constants.CONTENT_TYPES.MULTIPLE_CHOICE_BATTERY:
                return <MultipleChoiceBatteryType {...params} min={content.min} max={content.max} choices={content.choices} rows={content.rows} />;
            case constants.CONTENT_TYPES.MULTIPLE_NUMBER3_BATTERY:
                return <MultipleNumber3Type {...params} max={content.max} rows={content.rows} />;
            case constants.CONTENT_TYPES.LINK:
                return <LinkType {...params} text={content.text} href={content.href} blank={content.blank}
                    instanceId={instanceId} redirect={content.redirect} redirectTimeout={content.redirectTimeout} doRedirect={this.props.doRedirect} />;
            case constants.CONTENT_TYPES.IMAGE:
                return <ImageType {...params} required={content.required} lang={lang} />;
            case constants.CONTENT_TYPES.GEO:
                return <GeoType {...params} />;
            case constants.CONTENT_TYPES.RANK:
                return <RankType {...params} rows={content.rows} max={content.max} />;
            default:
                throw new Error(`Cannot find component for type "${content.type}".`);
        }
    }
}

Content.propTypes = {
    content: PropTypes.object.isRequired,
    instanceId: PropTypes.string,
    lang: PropTypes.string.isRequired,
    value: PropTypes.any,
    nextContent: PropTypes.object,
    previousContent: PropTypes.object,
    doRedirect: PropTypes.func,
};

const mapStateToProps = (state) => ({
    lang: state.language.current,
});

export default connect(mapStateToProps)(Content);
